import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Caption } from 'components/Typography/Typography';
import style from 'assets/jss/material-dashboard-pro-react/components/customCircularProgressStyle';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(style);

interface ICircularProgressProps {
	loading?: boolean;
	text: string;
	transparent?: boolean;
	negative?: boolean;
	whiteBackground?: boolean;
	size?: number;
}

const CustomCircularProgress = ({
	loading,
	text,
	transparent,
	negative,
	whiteBackground,
	size = 24,
}: ICircularProgressProps) => {
	const classes = useStyles();

	return (
		<>
			{loading && (
				<div
					className={classNames(classes.circularProgressWrapper, {
						[classes.transparentCircularProgressWrapper]: transparent,
						[classes.whiteBackgroundCircuralProgressWrapper]: whiteBackground,
					})}
				>
					<div>
						<CircularProgress size={size} />
						<CircularProgress
							size={size}
							className={classes.backgroundCircle}
							variant="determinate"
							value={100}
						/>
					</div>
					{!!text && (
						<div>
							<Caption color={negative ? 'disabled-dark' : 'disabled-light'} disableMargin>
								{text}
							</Caption>
						</div>
					)}
				</div>
			)}
		</>
	);
};

export default CustomCircularProgress;
